import React, { useEffect, useState } from "react";
import { C } from "../lib/colors.js";
import { readSessionStorage, stampReload } from "../lib/chunkReload.js";
import { onStaleBundle } from "../lib/staleBundle.js";
import { surface, ui } from "../lib/telemetry/instrument.js";
import { Button } from "./ui/Primitives.jsx";

/**
 * The guided reload offered when lib/staleBundle.js raises a notice (the wire gate dropped rows
 * from a list load). It never reloads on its own and its copy claims no more than the gate
 * knows: a dropped row can also be a nonconforming STORED row, which no reload fixes — the user
 * decides. Mount once, beside `<Toaster/>`.
 */
export default function StaleBundleBanner() {
  const [notice, setNotice] = useState(null);
  useEffect(() => onStaleBundle((n) => setNotice(n)), []);
  if (!notice) return null;
  return (
    <div
      role="status"
      {...surface("stale-bundle")}
      style={{
        position: "fixed",
        top: 12,
        left: "50%",
        transform: "translateX(-50%)",
        zIndex: 9000,
        display: "flex",
        alignItems: "center",
        gap: 12,
        maxWidth: "min(560px, 92vw)",
        background: C.panel,
        border: `1px solid ${C.border}`,
        borderRadius: 10,
        boxShadow: C.shadowBox,
        padding: "10px 14px",
        fontSize: 13,
        lineHeight: 1.5,
        color: C.white,
        boxSizing: "border-box",
      }}
    >
      <span>
        Some forecasts could not be loaded. This tab may be out of date — reload to pick up the
        current version.
      </span>
      <Button
        variant="primary"
        size="sm"
        {...ui("stale-bundle.reload")}
        onClick={() => {
          stampReload(readSessionStorage(window), Date.now());
          window.location.reload();
        }}
      >
        Reload
      </Button>
      <Button
        variant="ghost"
        size="sm"
        {...ui("stale-bundle.dismiss")}
        onClick={() => setNotice(null)}
      >
        Dismiss
      </Button>
    </div>
  );
}
